module.exports = __webpack_public_path__ + "img/danger_detail.8b580b9d.png";